import {inlineError} from '@s-ui/decorators'

import {RatingsRepository} from './RatingsRepository.js'

export class HttpRatingsRepository extends RatingsRepository {
  constructor({config, fetchOrFail, cancelTradeRatingsError, statusTradeRatingsValueObjectFactory}) {
    super()

    this._config = config
    this._fetchOrFail = fetchOrFail
    this._cancelTradeRatingsError = cancelTradeRatingsError
    this._statusTradeRatingsValueObjectFactory = statusTradeRatingsValueObjectFactory
    this._apiUrl = this._config.get('API_URL')
  }

  @inlineError
  async cancelTrade({requestVO}) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const {NOT_FOUND} = this._config.get('COMMON').HTTP_STATUS_CODES

    const url = `${this._apiUrl}/ratings/cancel`

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._cancelTradeRatingsError(message)
        },
        [NOT_FOUND]: ({message}) => {
          return this._cancelTradeRatingsError(message)
        }
      })
      .post(url, requestVO.toJSON())

    const {status} = response

    if (error) return Promise.reject(error)
    return this._statusTradeRatingsValueObjectFactory({status})
  }
}
